import { CUSTOMER_API, CLIENT_ID } from 'constants/ResourcesConstants'
import { X_WWW_FORM } from 'constants/RequestContentType'
import { serializeObject, getAuthorizationHeader } from 'utils/Helpers'

export async function fetchTokenForDriftt(driftt_token) {
  const request = fetch(`${ CUSTOMER_API }/oauth/token`, {
    method: 'POST',
    headers: {
      'Content-Type': X_WWW_FORM
    },
    body: serializeObject({
      driftt_token: driftt_token,
      grant_type: 'driftt',
      client_id: CLIENT_ID,
      redirect_uri: 'http://localhost:3000/'
    })
  })
  return request
}

export function fetchOauthCode({ redirect_uri, client_id }) {
  const request = fetch(`${ CUSTOMER_API }/oauth/auth`, {
    method: 'POST',
    headers: _.extend({ 'Content-Type': X_WWW_FORM }, getAuthorizationHeader()),
    body: serializeObject({
      response_type: 'code',
      client_id,
      access_type: 'offline',
      redirect_uri
    })
  })
  return request
}

export function fetchOAuthAppInfo(client_id) {
  const request = fetch(`${ CUSTOMER_API }/oauth/applications?clientId=${ client_id }`, {
    method: 'GET',
    headers: getAuthorizationHeader()
  })
  return request
}



// WEBPACK FOOTER //
// ./src/scripts/app/api/TokenAPI.js